import Tab from "../../../../modules/boot/js/tab";

const Tariffs = {
	change: function ($carousel) {
		const slider = $carousel.swiper;
		const $tab = $carousel.closest('#nav-tariffs');

		const $btnSlidePrev = $tab.querySelector('.swiper-button-prev');
		const $btnSlideNext = $tab.querySelector('.swiper-button-next');

		$btnSlidePrev.addEventListener('click', () => {
			const tabElActive = $tab.querySelector('[data-bs-toggle="tab"].active');
			let indexElActive = parseInt(tabElActive.dataset.index) - 1;

			if (indexElActive >= 0) {
				changeContent(indexElActive)
			}
		});

		$btnSlideNext.addEventListener('click', () => {
			const tabElActive = $tab.querySelector('[data-bs-toggle="tab"].active');
			let indexElActive = parseInt(tabElActive.dataset.index) + 1;

			if (indexElActive >= 0) {
				changeContent(indexElActive)
			}
		});

		function changeContent(indexElActive) {
			slider.slideTo(indexElActive);

			const tabEl = $tab.querySelector('[data-bs-toggle="tab"][data-index="'+ indexElActive +'"]');
			const tab = new Tab(tabEl);

			tab.show();
		}
	}
}

function onReady() {
	let $carousel = document.getElementById('swiper-tariffs');

	if ($carousel) {
		Tariffs.change($carousel);
	}
}

document.addEventListener("DOMContentLoaded", onReady);

export default Tariffs;